<script>
import _ from 'lodash'

export default {
  methods: {
    generateRevRoute(organizationId, revType, revId) {
      if (revType === 'improvementIdea')
        return `/rev/${organizationId}/${revId}`
      return `/${_.kebabCase(revType)}/${organizationId}/${revId}`
    },

    getRevStatus(rev) {
      return rev.status || rev.revCondition
    },

    isRevValidated(rev) {
      return Boolean(
        rev?.validations?.implementation?.isValidated ??
          rev?.metadata?.validations?.implementation?.isValidated ??
          rev?.metadata?.validations__implementation__isValidated ??
          rev?.validations?.implementation?.isValidated ??
          rev?.validation?.implementation ??
          rev?.validations__implementation__isValidated ??
          false
      )
    },

    isFinanciallyValidated(rev) {
      return Boolean(
        rev?.validations?.financial?.isValidated ??
          rev?.metadata?.validations?.financial?.isValidated ??
          rev?.metadata?.validations__financial__isValidated ??
          rev?.validations?.financial?.isValidated ??
          rev?.validation?.financial ??
          rev?.validations__financial__isValidated ??
          false
      )
    },

    isHighlighted(rev) {
      return (
        rev?.isHighlighted ??
        rev?.validation?.highlight ??
        rev?.metadata?.isHighlighted ??
        rev?.metadata?.highlight__isHighlighted ??
        false
      )
    },

    getRevCurrency(rev) {
      return (
        rev?.financialMetadata?.revCurrency ??
        rev?.financialMetadata?.currency ??
        rev?.currencyMetadata?.currentCurrency ??
        ''
      )
    },

    getOrganizationCurrency(rev) {
      return rev?.location?.organization?.currency ?? ''
    },

    getExchangeRate(rev) {
      return parseFloat(
        rev?.financialMetadata?.exchangeRate ??
          rev?.currencyMetadata?.exchangeRate ??
          0
      )
    },
  },
}
</script>
